<template>
  <div class="pa-3 mb-3 d-flex align-center">
    <div
      v-if="loading"
      class="d-flex align-center"
      style="width: 100%; min-height: 200px"
    >
      <v-row no-gutters align="center">
        <v-col cols="12" md="3" class="d-flex justify-center align-center my-3">
          <v-skeleton-loader
            width="45%"
            height="10vh"
            type="image"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="9">
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
    <div v-if="!loading && dataSet" style="width: 100%">
      <v-row no-gutters>
        <v-col cols="10">
          <h3 class="d-flex">
            Hi,
            <span class="color_default text-capitalize ml-2">
              {{ dataSet.name.charAt(0).toUpperCase() + dataSet.name.slice(1) }}
            </span>
          </h3>
        </v-col>
        <!-- <v-col cols="2">
            <v-btn
              x-small
              fab
              depressed
              color="#006341"
              :to="`/profile/edit-scholar/${this.dataSet.id}`"
            >
              <v-icon color="white">mdi-pencil-outline</v-icon>
            </v-btn>
          </v-col> -->
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" sm="3" md="3" lg="3">
          <div class="pa-2 avatar_ppl">
            <div style="position: relative;width:150px;height;150px;">
              <div>
                <v-avatar size="150">
                  <img
                    :src="
                      dataSet.profile_picture ? dataSet.profile_picture : ava
                    "
                    class="obj_fit"
                  />
                </v-avatar>
              </div>
              <div style="position: absolute; top: 100px; right: -5px">
                <v-btn
                  depressed
                  fab
                  color="blue"
                  small
                  dark
                  @click="$refs.file.click()"
                >
                  <input
                    type="file"
                    ref="file"
                    @change="uploadImage($event)"
                    accept="image/*"
                    class="input_hide"
                  />
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9">
          <div class="label_on_profile">
            <v-card
              flat
              color="#0063414D"
              class="rounded-pill mr-2 mb-2 py-2 px-3"
            >
              <h5 class="color_default">
                {{ dataSet.no_tf ? dataSet.no_tf : "-" }}
              </h5>
            </v-card>
            <router-link
              v-if="dataSet.university_id"
              class="no_decoration"
              :to="`/scholar/tsa/detail-tanoto-scholar-academy/${dataSet.university_id.id}`"
            >
              <v-card
                flat
                color="#0063414D"
                class="rounded-pill mr-2 py-2 mb-2 px-3"
              >
                <h5 style="color: #006341">
                  {{ dataSet.university_id.name }}
                </h5>
              </v-card>
            </router-link>
          </div>
          <v-row no-gutters>
            <v-col cols="12" md="4" lg="4">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="pa-1">
                    <b class="small_txt">Username</b>
                    <p class="default_txt">
                      {{ dataSet.username ? dataSet.username : "-" }}
                    </p>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="pa-1">
                    <b class="small_txt">Full Name</b>
                    <p class="default_txt">
                      {{ dataSet.name ? dataSet.name : "-" }}
                    </p>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="pa-1">
                    <b class="small_txt">Email</b>
                    <p class="default_txt">
                      {{ dataSet.email ? dataSet.email : "-" }}
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <!-- ===================================================>> -->
            <v-col cols="12" md="4" lg="4">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="pa-1">
                    <b class="small_txt">NIK</b>
                    <p class="default_txt">
                      {{ dataSet.nik ? dataSet.nik : "-" }}
                    </p>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="px-1 d-flex">
                    <div>
                      <b class="small_txt">Whatsapp Number</b>
                      <p class="default_txt">
                        {{ dataSet.wa_number ? dataSet.wa_number : "-" }}
                      </p>
                    </div>
                    <v-btn
                      icon
                      class="ml-5"
                      x-small
                      fab
                      depressed
                      @click="editProfilPerKey('wa_number', 'No. WA')"
                      color="#006341"
                    >
                      <v-icon color="#006341">mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="ml-2"
                          x-small
                          fab
                          depressed
                          @click="hideColumn('wa_number')"
                          color="#006341"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="#006341"
                            >mdi-eye{{
                              hide_column.includes("wa_number") ? "-off" : ""
                            }}</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>{{
                        hide_column.includes("wa_number")
                          ? "Unhide Whatsapp Number"
                          : "Hide Whatsapp Number"
                      }}</span>
                    </v-tooltip>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="px-1 d-flex">
                    <div>
                      <b class="small_txt">Address</b>
                      <p class="default_txt">
                        {{ dataSet.address ? dataSet.address : "-" }}
                      </p>
                    </div>
                    <v-btn
                      icon
                      class="ml-5"
                      x-small
                      fab
                      depressed
                      @click="editProfilPerKey('address', 'Address')"
                      color="#006341"
                    >
                      <v-icon color="#006341">mdi-pencil-outline</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <!-- ===================================================>> -->
            <v-col cols="12" md="4" lg="4">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="pa-1">
                    <b class="small_txt">Gender</b>
                    <p class="default_txt">
                      {{ dataSet.gender ? dataSet.gender : "-" }}
                    </p>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="px-1 d-flex">
                    <div>
                      <b class="small_txt">Major</b>
                      <p class="default_txt">
                        {{ dataSet.major ? dataSet.major : "-" }}
                      </p>
                    </div>
                    <v-btn
                      icon
                      class="ml-5"
                      x-small
                      fab
                      depressed
                      @click="editProfilPerKey('major', 'Major')"
                      color="#006341"
                    >
                      <v-icon color="#006341">mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="ml-2"
                          x-small
                          fab
                          depressed
                          @click="hideColumn('major')"
                          color="#006341"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="#006341"
                            >mdi-eye{{
                              hide_column.includes("major") ? "-off" : ""
                            }}</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>{{
                        hide_column.includes("major")
                          ? "Unhide Major"
                          : "Hide Major"
                      }}</span>
                    </v-tooltip>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="pa-1">
                    <b class="small_txt">University</b>
                    <p class="default_txt">
                      {{
                        dataSet.university_id
                          ? `${dataSet.university_id.name}`
                          : "-"
                      }}
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <!-- ===================================================>> -->
          </v-row>
          <div class="px-1 d-flex">
            <div class="">
              <b class="small_txt">Bio</b>
              <p
                class="default_txt"
                v-if="dataSet.about"
                v-html="dataSet.about"
              ></p>
              <p class="default_txt" v-else></p>
            </div>
            <v-btn
              icon
              class="ml-5"
              x-small
              fab
              depressed
              @click="editBio"
              color="#006341"
            >
              <v-icon color="#006341">mdi-pencil-outline</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="pa-3">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-profile
        :d_profile="d_profile"
        @refetch="fetchData"
        @close="d_profile = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
        :width="d_width"
        :line="true"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dialogProfile from "../../../views/profile/dialogProfile.vue";
export default {
  components: { dialogProfile },
  data() {
    return {
      dataSet: null,
      d_profile: false,
      d_width: "450px",
      d_create: false,
      d_large: false,
      inventory: "",
      d_type: "",
      d_title: "",
      loading: false,
      image: {
        src: "",
        type: "image/jpg",
      },
      hide_column: [],
    };
  },
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
      ava: (state) => state.ava_lg,
      id: (state) => state.id,
      scholar: (state) => state.scholar,
    }),
  },
  name: "profile",
  props: ["idScholar"],
  mounted() {
    this.fetchData(true);
  },
  methods: {
    fetchData(first) {
      if (first) {
        this.loading = true;
      }
      let data = {
        path: `manage/scholar?filter[user_id]=${this.idScholar}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.hide_column = data.data[0].hide
            ? JSON.parse(data.data[0].hide)
            : [];
          this.getProfile(data.data[0].id);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    async getProfile(id) {
      let data = {
        path: `scholar?scholar_id=${id}`,
      };
      await this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.$store.commit("GET_PROFILE", data);
          this.dataSet = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
      if (this.dataSet.university_id) {
        this.dataSet.university_id = this.dataUniv(this.dataSet.university_id);
      }
      this.loading = false;
    },
    dataUniv(idx) {
      let univ = { id: idx, name: null };
      let data = {
        path: `manage/univ/get?filter[id]=${idx}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          univ.name = data.data[0].name;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
      return univ;
    },
    uploadImage(event) {
      /// Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. Update the image. The type will be derived from the extension and it can lead to an incorrect result:
        this.image = {
          src: blob,
          type: files[0].type,
        };
        this.showCrop();
      }
    },
    showCrop() {
      this.d_type = "crop";
      this.d_title = "Change profile picture";
      this.d_create = true;
      this.inventory = this.image;
    },
    editBio() {
      this.d_type = "u_bio";
      this.d_title = "Edit Bio";
      this.inventory = {
        id: this.id,
        bio: this.dataSet.about,
      };
      this.d_width = "50%";
      this.d_profile = true;
    },
    editProfilPerKey(key, label) {
      this.d_type = "u_profileScholarPerKey";
      this.d_title = "Edit " + label;
      this.inventory = {
        id: this.id,
        body: {
          [key]: this.dataSet[key],
        },
        key_profile: key,
        txt_label: label,
      };
      this.d_width = "50%";
      this.d_profile = true;
    },
    hideColumn(key) {
      if (this.hide_column.includes(key)) {
        this.hide_column.splice(this.hide_column.indexOf(key), 1);
      } else {
        this.hide_column.push(key);
      }
      let body = new FormData();
      body.append("scholar_id", this.scholar);
      body.append("hide", JSON.stringify(this.hide_column));
      let data = {
        path: `scholar/hide`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.button-wrapper {
  display: flex;
  justify-content: center;
}
.input_hide {
  display: none;
}
</style>
